import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Banner } from "./components/Banner";
import { Skills } from "./components/Skills";
import { Projects } from "./components/Projects";
import { Contact } from "./components/Contact";
import { NavBar } from './components/Navbar';
import { Footer } from './components/Footer';
import Navigation from './Navigation';

function App() {
  return (
    <div className="App">
      <Navigation/>
    </div>
  );
}

export default App;